module.exports = __webpack_public_path__ + "static/media/flatbread-nav-inactive.a480aaaf.svg";